<template>
    <div class="pf_wrapper">
        <div class="pf_closeBtn">
            <feather-icon icon="XIcon" @click="closePage"/>
        </div>
        <div class="pf_title">
            <h1>Informações Complementares</h1>
        </div>
        <div class="pf_content">
            <vs-row>
                <div class="pf_group">
                    <span class="mb-3">
                        <b>Disponível para</b>
                    </span>
                    <vs-col class="mb-3" vs-sm="12" vs-lg="6" vs-type="flex" vs-justify="space-between">
                        <label for="">Novas oportunidades:</label>
                            <vs-switch v-model="payload.available">
                                <span slot="on">Sim</span>
                                <span slot="off">Não</span>
                            </vs-switch>
                    </vs-col>
                    <vs-col class="mb-3" vs-sm="12" vs-lg="6" vs-type="flex" vs-justify="space-between">
                        <label for="">Trabalho remoto:</label>
                            <vs-switch v-model="payload.remote">
                                <span slot="on">Sim</span>
                                <span slot="off">Não</span>
                            </vs-switch>
                    </vs-col>
                    <vs-col class="mb-3" vs-sm="12" vs-lg="6" vs-type="flex" vs-justify="space-between">
                        <label for="">Viajar a trabalho:</label>
                            <vs-switch v-model="payload.relocation">
                                <span slot="on">Sim</span>
                                <span slot="off">Não</span>
                            </vs-switch>
                    </vs-col>
                </div>
                <div class="pf_group">
                    <span class="mb-3">
                        <b>Pronome</b>
                    </span>
                    <vs-col class="mb-3" vs-sm="12" vs-lg="6">
                        <v-select
                            id="pronouns"
                            class="w-full"
                            clearable
                            placeholder="Escolha uma opção"
                            :options="pronouns"
                            :reduce="p => p.value"
                            v-model="payload.pronoun_id"
                        />
                    </vs-col>
                </div>
                <div class="pf_group">
                    <span class="mb-3">
                        <b>Contratação</b>
                    </span>
                    <vs-col class="mb-3" vs-sm="12" vs-lg="6">
                        <label for="">Regime de Contratação:</label>
                        <v-select
                            class="w-full"
                            multiple
                            placeholder="Escolha uma modalidade"
                            :options="regime_options"
                            :reduce="regime => regime.value"
                            v-model="payload.regimes"
                        />
                    </vs-col>
                </div>
                <div class="pf_group">
                    <span class="mb-3">
                        <b>Redes Sociais</b>
                    </span>
                    <vs-col class="mb-3" vs-sm="12" vs-lg="6">
                        <label for="">Facebook:</label>
                        <vs-input
                            class="no-icon-border ml-2 w-full"
                            v-model="payload.facebook_url"
                            name="facebook_url"
                            placeholder="https://facebook.com/br"
                            type="text"
                        />
                    </vs-col>
                    <vs-col class="mb-3" vs-sm="12" vs-lg="6">
                        <label for="">LinkedIn:</label>
                        <vs-input
                            class="no-icon-border ml-2 w-full"
                            v-model="payload.linkedin_url"
                            name="linkedin_url"
                            placeholder="https://linkedin.com/br"
                            type="text"
                        />
                    </vs-col>
                    <vs-col class="mb-3" vs-sm="12" vs-lg="6">
                        <label for="">Website ou Portfolio:</label>
                        <vs-input
                            class="no-icon-border ml-2 w-full"
                            v-model="payload.website_url"
                            name="website_url"
                            placeholder="https://website.com/br"
                            type="text"
                        />
                    </vs-col>
                    <vs-col class="mb-3" vs-sm="12" vs-lg="6">
                        <label for="">Github:</label>
                        <vs-input
                            class="no-icon-border ml-2 w-full"
                            v-model="payload.github_url"
                            name="github_url"
                            placeholder="https://github.com"
                            type="text"
                        />
                    </vs-col>
                </div>
                <div class="pf_group">
                    <vs-col vs-sm="12" vs-lg="6">
                        <vs-button
                            @click="handleSaveProfessionalProfile"
                            class="w-full"
                            color="primary"
                            type="filled"
                        >
                            Atualizar informações complementares
                        </vs-button>
                    </vs-col>
                </div>
            </vs-row>
        </div>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import vSelect from 'vue-select'
import { get, keys, set } from 'lodash'

export default {
    components: {
        ModelSelect,
        'v-select': vSelect,
    },
    data: () => ({
        payload: {
            available: false,
            relocation: false,
            remote: false,
            description: '',
            pronoun_id: null,
            regimes: [],
            facebook_url: '',
            linkedin_url: '',
            github_url: '',
            website_url: ''
        },
        pronouns: [],
        regime_options: [
            { label: 'Pessoa Jurídica', value: 'Pessoa Jurídica' },
            { label: 'Carteira Assinada (CLT)', value: 'Carteira Assinada (CLT)' },
            { label: 'Estágio', value: 'Estágio' },
        ],
    }),
    methods: {
        closePage() {
            this.$router.push({
                name: 'dashboard-profile-detail'
            });
        },
        handleSaveProfessionalProfile () {
            this.$vs.loading();

            const label = localStorage.getItem('label');
            const {
                pronoun_id,
                intended_remuneration,
                remuneration,
                ...professionalPayload
            } = this.payload;
            const diversityState = this.$store.state.diversity;

            this.$http.post(`api/v1/talent/${label}/user/professional-profile`, professionalPayload)
                .then(() => {
                    return this.$http.post('/api/v1/diversity', {
                        ...diversityState,
                        pronoun_id,
                        is_egression: diversityState.is_egression !== undefined ? diversityState.is_egression : false,
                        pcd_reability: diversityState.pcd_reability !== undefined ? diversityState.pcd_reability : false,
                    });
                })
                .then((response) => {
                    this.$store.dispatch('diversity/addDiversity', response.data);
                    this.$vs.loading.close();
                    this.$store.dispatch('professional_profile/addProfessionalProfile', professionalPayload);
                    this.$router.push({
                        name: 'dashboard-profile-detail'
                    });
                })
                .catch(() => {
                    this.$vs.loading.close();
                });
        },
        mapDiversityOptions(res) {
            const data = res.data !== undefined ? res.data : res;
            const options = {};
            keys(data).forEach((key) => {
                set(
                    options,
                    key,
                    data[key].map((item) => ({
                        label: item.name,
                        value: item.id,
                        description: item.description ? item.description : null,
                    }))
                );
            });
            return get(options, 'pronouns', []);
        },
        fetchProfessionalDetail() {
            this.$vs.loading();

            const label = localStorage.getItem('label');

            Promise.all([
                this.$http.get(`api/v1/talent/${label}/user/talent?step=professional_profile`),
                this.$http.get('/api/v1/diversity?debug=true'),
            ])
                .then(([talentRes, diversityRes]) => {
                    this.$vs.loading.close();
                    const {
                        talent,
                        professional_profile,
                    } = talentRes.data.data;

                    const pronounFromStore = this.$store.state.diversity.pronoun;
                    const pronounFromApi = talent.pronoun;
                    const activePronoun = pronounFromStore || pronounFromApi;
                    const pronoun_id = activePronoun && activePronoun.id ? activePronoun.id : null;

                    this.pronouns = this.mapDiversityOptions(diversityRes);

                    this.payload = {
                        ...talent,
                        ...professional_profile,
                        regimes: professional_profile.regimes
                            ? professional_profile.regimes.split(',')
                            : [],
                        pronoun_id,
                        available:
                            professional_profile.available === 'Não' ||
                            !professional_profile.available
                                ? false
                                : true,
                        relocation:
                            professional_profile.relocation === 'Não' ||
                            !professional_profile.relocation
                                ? false
                                : true,
                        remote:
                            professional_profile.remote === 'Não' ||
                            !professional_profile.remote
                                ? false
                                : true,
                    };
                })
                .catch((error) => {
                    this.$vs.loading.close();
                    console.error({ error });
                });
        },
    },
    created: function() {
        window.scrollTo(0, 0);
        this.fetchProfessionalDetail();
    }
}
</script>

<style lang="scss" scoped>
.pf_wrapper {
    min-height: 100vh;
    width: 100%;
    padding: 16px;
    background: #fff;

    @media screen and (min-width: 768px) {
        padding: 36px;
    }
}

.pf_closeBtn {
    display: flex;
    justify-content: flex-end;
}

.pf_title {
    display: flex;
    justify-content: center;

    h1 {
        font-size: 20px;
    }
}

.pf_content {
    padding: 16px 0;
    display: flex;
    justify-content: center;
}

.pf_group {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 16px 0;
}

</style>